import unset from 'lodash/unset';
import Router from 'next/router';

import prepareHref from '../prepareHref';

const removeQueryParams = (brand) => (keys, type = 'push') => {
  if (!window) {
    return;
  }

  const { router } = Router;
  const { query } = router;

  if (Array.isArray(keys)) {
    keys.forEach((key) => unset(query, key));
  } else {
    unset(query, keys);
  }

  const { href: hrefObject, as } = prepareHref(
    {
      pathname: router.pathname,
      query,
    },
    brand
  );

  Router[type](hrefObject, as, { shallow: true });
};

export default removeQueryParams;
